import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  resolveInitialLanguage,
  type AppLanguage,
} from './languages';
import en from './locales/en.json';
import ru from './locales/ru.json';
import hy from './locales/hy.json';
import uz from './locales/uz.json';
import kk from './locales/kk.json';
import tr from './locales/tr.json';
import uk from './locales/uk.json';

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  hy: { translation: hy },
  uz: { translation: uz },
  kk: { translation: kk },
  tr: { translation: tr },
  uk: { translation: uk },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setAppLanguage(lang: AppLanguage) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  document.documentElement.lang = lang;
  return i18n.changeLanguage(lang);
}

document.documentElement.lang = i18n.language;

// CF / GeoIP refine well after first paint — keep it off the critical request chain.
function scheduleLanguageRefine() {
  const run = () => {
    void import('./refineLanguage').then((m) => m.refineLanguageFromServer());
  };
  if (typeof window === 'undefined') return;
  const start = () => {
    const ric = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number })
      .requestIdleCallback;
    if (typeof ric === 'function') {
      ric(() => run(), { timeout: 4000 });
    } else {
      window.setTimeout(run, 1500);
    }
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}

scheduleLanguageRefine();

export default i18n;
